import { browserDownloadFileFromText } from '../../../utils/petfUtils';

// eslint-disable-next-line import/prefer-default-export
export function downloadPrclFile(fileName: string, rundef: string) {
  const fileContent = `[ProtocolRunDefinition version 06.00]${rundef}`;
  const fileNameWithEnding = `${fileName}.prcl`;
  browserDownloadFileFromText(fileNameWithEnding, fileContent);
}
